import { Box, Button, Stack, Typography, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const GeneralPOIInfoPanel = muiStyled(Box)(() => ({
  borderRadius: '8px',
  background: abyssColors.primary[50],
  padding: '24px',
  display: 'flex',
  alignItems: 'center',
  minHeight: '90px',
  marginTop: '16px',
  justifyContent: 'space-between',
}));

export const GeneralInfo = muiStyled(Stack)(() => ({
  gap: '8px',
}));

export const IconLabel = muiStyled(Stack)(() => ({
  gap: '4px',
  flexDirection: 'row',
}));

export const GeneralLabel = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  fontSize: '1.2rem',
}));

export const GeneralIconLabel = muiStyled(Typography)(() => ({
  color: abyssColors.primary[400],
  fontSize: '1.2rem',
}));

interface ValueProps {
  customColor?: string;
}

export const GeneralValue = muiStyled(Typography)(({ customColor }: ValueProps) => ({
  color: customColor ?? abyssColors.primary[500],
  fontSize: '1.4rem',
  fontWeight: 700,
  maxWidth: '300px',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  paddingRight: '10px',
}));

export const iconStyles = {
  fontSize: '1.6rem',
  color: abyssColors.primary[300],
};

export const SplitContainer = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  marginTop: '24px',
}));

export const POIDetails = muiStyled(Stack)(() => ({
  flex: '0 0 auto',
  width: '20%',
  overflow: 'hidden',
  paddingLeft: '8px',
  paddingRight: '8px',
}));

export const POIMedia = muiStyled(Stack)(() => ({
  flex: 1,
  width: '80%',
  gap: '2.4rem',
}));

export const DetailHeading = muiStyled(Typography)(() => ({
  color: abyssColors.primary[700],
  fontSize: '1.4rem',
  fontWeight: 500,
  marginBottom: '20px',
}));

export const DetailLabel = muiStyled(Typography)(() => ({
  color: abyssColors.primary[400],
  fontSize: '1.2rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
}));

export const DetailValue = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  fontSize: '1.6rem',
  fontWeight: 500,
  lineHeight: 'normal',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
}));

export const DetailBox = muiStyled(Stack)(() => ({
  gap: '4px',
  marginBottom: '16px',
}));
export const ImageFrame = muiStyled(Box)(() => ({
  width: '100%',
  height: '100%',
  minHeight: '280px',
  borderRadius: '8px',
  border: '1px solid rgba(0, 0, 0, 0.50)',
  overflow: 'hidden',
  position: 'relative',
}));
export const ImageUploadPanel = muiStyled(Stack)(() => ({
  width: '100%',
  height: '72px',
  backgroundColor: abyssColors.primary[50],
  borderRadius: '4px',
  border: `1px dashed ${abyssColors.primary[200]}`,
  padding: '24px',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const UploadButton = muiStyled(Button)(() => ({
  padding: '4px 8px',
  borderRadius: '4px',
  border: `1px solid ${abyssColors.primary[500]}`,
  color: abyssColors.primary[500],
  fontSize: '1.2rem',
  fontWeight: 600,
  textTransform: 'none',
  lineHeight: '16px',
  height: 'auto',
  display: 'flex',
  alignItems: 'center',
  '& span': {
    marginLeft: '6px',
    marginRight: '6px',
  },
}));

export const RemoveOverlay = muiStyled(Stack)(() => ({
  position: 'absolute',
  background: `linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%)`,
  borderRadius: '4px',
  flexDirection: 'row-reverse',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  padding: '12px',
}));

export const ActionButton = muiStyled(Button)(() => ({
  padding: '4px 8px',
  height: '26px',
  borderRadius: '4px',
  boxShadow: 'none',
  border: `1px solid ${abyssColors.neutral[200]} !important`,
}));

export const ActionButtonLabel = muiStyled(Typography)(() => ({
  color: abyssColors.neutral[200],
  fontSize: '1.2rem',
  fontWeight: 600,
  margin: '0 6px',
  textTransform: 'none',
}));
